var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneNumberSwooshBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 421,
    viewBox: "0 0 390 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.029 589.96C225.216 592.797 267.969 582.106 304.009 548.633C368.58 488.66 364.007 436.14 396.633 386.541C429.259 336.943 493.837 315.702 522.103 287.678C553.378 256.671 561.96 171.551 534.297 116.589C506.818 62.5286 496.431 34.53 429.842 13.9457C354.629 -9.30476 298.626 44.533 215.936 32.9964C133.246 21.4599 74.2517 -15.1431 20.2278 7.27002C-36.4223 30.7725 -118.721 121.821 -107.241 212.356C-98.008 285.176 -27.5515 325.426 -11.187 396.382C5.17759 467.338 18.6515 513.47 45.4734 538.458C72.2456 563.399 113.241 587.518 165.029 589.96Z",
    fill: "url(#paint0_linear_959_28812)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_959_28812",
    x1: 9.08034,
    y1: 517.784,
    x2: 372.579,
    y2: -33.5952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8BBA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCAB4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumberSwooshBackground);
export default __webpack_public_path__ + "static/media/phone-number-swoosh-background.6d56728e15d4670558190e546e45dbf4.svg";
export { ForwardRef as ReactComponent };